<template>
  <div>
    <b-form-group :label="$t('field.name')">
      <b-form-input
        v-model="item.name"
        name="name"
        type="text"
        required
        placeholder="Lorem ipsum set dolor"
      />
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      item: 'form/fields'
    })
  }
}
</script>
